import { render } from "./CustomError404.vue?vue&type=template&id=51aadfd6"
import script from "./CustomError404.vue?vue&type=script&lang=js"
export * from "./CustomError404.vue?vue&type=script&lang=js"

import exportComponent from "/home/fran/Desarrollo/soyasi/ebim-crm/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"CustomError404.vue"]])

export default __exports__